import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/core/service/auth.service";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { IUser } from "src/app/core/model/User.model";
import { Observable } from "rxjs";

interface ROUTE {
  icon?: string;
  route?: string;
  title?: string;
}

@Component({
  selector: "app-admin-layout",
  templateUrl: "./admin-layout.component.html",
  styleUrls: ["./admin-layout.component.scss"],
})
export class AdminLayoutComponent implements OnInit {
  appTitle = environment.appTitle;
  currentUser = {} as IUser;

  myWorkRoutes: ROUTE[] = [
    {
      icon: "dashboard",
      route: "/",
      title: "Dashboards",
    },
  ];

  settingsRoutes: ROUTE[] = [
    {
      icon: "shop_two",
      route: "/admin/order",
      title: "Ordini",
    },
    {
      icon: "contacts",
      route: "/admin/customer",
      title: "Genitori",
    },
    {
      icon: "calendar_today",
      route: "/admin/presence",
      title: "Presenze",
    },
    {
      icon: "folder",
      route: "/admin/document",
      title: "Documenti",
    },
  ];

  adminSettings = [
    {
      icon: "supervised_user_circle",
      route: "/admin/staff",
      title: "Operatori",
    },
    {
      icon: "class",
      route: "/admin/class",
      title: "Stagioni",
    },
    {
      icon: "location_on",
      route: "/admin/office",
      title: "Sedi",
    },
    {
      icon: "shop",
      route: "/admin/catalog",
      title: "Servizi",
    },
    {
      icon: "credit_card",
      route: "/admin/promo-coupon",
      title: "Promo Coupon",
    },
    {
      icon: "people",
      route: "/admin/promo-son",
      title: "Promo Bambini",
    },
    {
      icon: "share",
      route: "/admin/news",
      title: "News",
    },
  ];

  constructor(private authSevice: AuthService, private router: Router) {}

  ngOnInit() {
    this.authSevice.getUserProfile().subscribe((user) => {
      this.currentUser = user;
    });
  }

  onSignOut() {
    this.authSevice.logout();
    this.router.navigate(["/login"]);
  }
}
